import { WorkflowFormKey, WorkflowTaskDefinitionKey, ITask, TaskHint } from '@lib/workflow-integration';
import { DemandDataService } from '../../demand/demand-data.service';
import { IPurchaseRequisition, PurchaseRequisition } from '../../purchase-requisition/types/PurchaseRequisition';
import { CommentDataService } from '@lib/comment';
import { ItemClassificationDataService } from '@lib/classification';
import { FileDataService } from '@lib/file';
import { ITaskInformation } from '@lib/util';
import { I18nService } from '@lib/i18n';

export interface IPurchaseRequisitionTask extends ITask {
    purchaseRequisition: IPurchaseRequisition;
    supplierChangeAllowed: boolean;
    requireValidSuppliers: boolean;
}

export class PurchaseRequisitionTask implements ITask {
    assignee: string;
    created: string;
    purchaseRequisition: PurchaseRequisition;
    supplierChangeAllowed: boolean;
    requireValidSuppliers: boolean;
    formKey: WorkflowFormKey;
    id: string;
    name: string;
    taskDefinitionKey: WorkflowTaskDefinitionKey;
    hint: TaskHint;

    public readonly info: ITaskInformation;

    constructor(
        dto: IPurchaseRequisitionTask,
        demandDataService: DemandDataService,
        commentDataService: CommentDataService,
        itemClassificationDataService: ItemClassificationDataService,
        fileDataService: FileDataService,
        i18n: I18nService
    ) {
        this.assignee = dto.assignee;
        this.created = dto.created;
        this.purchaseRequisition = new PurchaseRequisition(
            dto.purchaseRequisition,
            demandDataService,
            commentDataService,
            itemClassificationDataService,
            fileDataService,
            i18n
        );
        this.formKey = dto.formKey;
        this.id = dto.id;
        this.name = dto.name;
        this.taskDefinitionKey = dto.taskDefinitionKey;
        this.supplierChangeAllowed = dto.supplierChangeAllowed;
        this.requireValidSuppliers = dto.requireValidSuppliers;
        this.hint = dto.hint;
        this.info = {
            id: dto.id,
            assignee: dto.assignee,
        };
    }
}
